import { Module } from '@nestjs/common';
import { IMyDateRangeModel } from './model/DateRangeModel';
import { IMyDate } from './model/IMyDate';
import { AccountDto } from './model/dto/AccountDto';
import { GroupDto } from './model/dto/GroupDto';
import { CommissionDBRow } from './model/CommissionDBRow';
import { CurrencyPair } from './model/CurrencyPair';
import { TradeDto } from './model/dto/TradeDto';
import { RateDto } from './model/dto/RateDto';
import { PostingMethodDto } from './model/dto/PostingMethodDto';
import { StpAbosAccount } from './model/StpAbosAccount';

@Module({
  controllers: [],
  providers: [
    // Currency,
    // IMyDateRangeModel,
    // IMyDate
    AccountDto,
    GroupDto,
    PostingMethodDto,
    RateDto,
    TradeDto,
    CommissionDBRow,
    CurrencyPair,
    IMyDateRangeModel,
    IMyDate,
    StpAbosAccount
  ],
  exports: [
    // Currency,
    // IMyDateRangeModel,
    // IMyDate
    AccountDto,
    GroupDto,
    PostingMethodDto,
    RateDto,
    TradeDto,
    CommissionDBRow,
    CurrencyPair,
    IMyDateRangeModel,
    IMyDate,
    StpAbosAccount
  ],
})
export class CommonModule {

}
